(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('WineDrinkDialogController', WineDrinkDialogController);

	WineDrinkDialogController.$inject = ['$window', '$mdDialog', 'WineDrink', 'userPouch', 'wine', 'lodash', 'transaction', 'combinedHistoryIndex', 'MessageService', '$log', 'persistOnSave', '$timeout', '$rootScope'];

	function WineDrinkDialogController($window, $mdDialog, WineDrink, userPouch, wine, lodash, transaction, combinedHistoryIndex, MessageService, $log, persistOnSave, $timeout, $rootScope){

		/* jshint validthis: true */
		var self = this;

		self.wine = wine;

		self.drink = null;

		self.maxBottles = lodash.get(wine, 'cellar.qty');

		self.isEdit = false;

		self.persistOnSave = persistOnSave;

		self.save = save;
		self.closeDialog = closeDialog;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){
			if (lodash.isNotEmptyOrNull(transaction)){
				// angular datepicker wants js Date
				// @TODO fix with $mdDateLocaleProvider?
				$timeout(function(){
					transaction.date = lodash.isNotEmptyOrNull(transaction.date) ? $window.moment(transaction.date).toDate() : null;
					self.drink = transaction;
				});

				self.isEdit = true;

				// adjust max bottle limit
				self.maxBottles = lodash.add(lodash.get(wine, 'cellar.qty'), transaction.qty);

			} else {
				self.drink = new WineDrink();
			}
		}

		function save(){

			$log.debug('Saving transaction...');

			// @TODO add preUpdate event & handler?

			// update ratings at wine level
			if (lodash.isNotEmptyOrNull(self.drink.rating.general)){
				lodash.set(self.wine, 'rating.user.general', self.drink.rating.general);
			}

			if (lodash.isNotEmptyOrNull(self.drink.rating.point)){
				lodash.set(self.wine, 'rating.user.point', self.drink.rating.point);
			}

			self.drink.qty = lodash.parseInt(self.drink.qty);

			self.wine.upsertCombinedHistoryItem(self.drink, combinedHistoryIndex);

			if (persistOnSave){
				return _persist();
			} else {
				closeDialog();
				$rootScope.$emit('WineTransactionAddedButNotSaved');
				_showPostSaveToast();
			}
		}

		function closeDialog(){
			return $mdDialog.hide();
		}

		function _showPostSaveToast(){
			var msg = "Drink " + (self.isEdit ? 'Updated' : 'Added') + ". Don't forget to save when done editing.";

			return MessageService.showToast(msg, 5000);
		}

		function _persist(){
			userPouch
				.save(self.wine)
				.then(function(){
					return MessageService.showToast('Drink saved!', 5000);
				})
				.then(closeDialog)
				.catch(function(err){
					$log.error('Error saving wine.', err);
					MessageService.showToast('Unable to save. Please contact support if problem persists', 5000);
				});
		}
	}

})();
